/**
 * exp/related-customer-cases — compact story-style cards Swiper (same behaviour as story-slider).
 * Scoped under .exp-related-customer-cases so story-slider on the same page is not initialized twice.
 */
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

import 'swiper/css';

const roots = document.querySelectorAll('.exp-related-customer-cases .exp-story-slider-sub');

roots.forEach((root) => {
	const el = root.querySelector('.swiper-container-story-slider-sub');

	if (!el) {
		return;
	}

	const prevEl = root.querySelector('.swiper-button-prev');
	const nextEl = root.querySelector('.swiper-button-next');

	// eslint-disable-next-line no-new
	new Swiper(el, {
		modules: [Navigation],
		loop: false,
		slidesPerView: 1.2,
		slidesToScroll: 1,
		spaceBetween: 32,
		watchOverflow: true,
		navigation: {
			prevEl: prevEl || null,
			nextEl: nextEl || null,
		},
		breakpoints: {
			1024: {
				slidesPerView: 3,
				slidesToScroll: 1,
			},
		},
	});
});
